// src/components/Header.js - Admin Header for Template Marketplace
import React from 'react';
import {
  Home,
  LayoutGrid,
  Sparkles,
  BarChart,
  FileSpreadsheet,
  ChevronDown,
} from 'lucide-react';

const Header = ({ currentPage, setCurrentPage, user = null }) => {
  const navigation = [
    { name: 'Dashboard', key: 'dashboard', icon: Home },
    { name: 'Templates', key: 'templates', icon: LayoutGrid },
    { name: 'AI Builder', key: 'ai-builder', icon: Sparkles },
    { name: 'Analytics', key: 'analytics', icon: BarChart },
    { name: 'Google Sheets', key: 'sheets-setup', icon: FileSpreadsheet },
  ];

  return (
    <header className="bg-white shadow border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo and Main Nav */}
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <h1 className="text-xl font-bold text-gray-900">TrackerSheets</h1>
            </div>
            <nav className="hidden md:ml-8 md:flex md:space-x-8">
              {navigation.map((item) => {
                const Icon = item.icon;
                return (
                  <button
                    key={item.key}
                    onClick={() => setCurrentPage(item.key)}
                    className={`inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium transition-colors ${
                      currentPage === item.key
                        ? 'border-blue-500 text-gray-900'
                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                    }`}
                  >
                    <Icon className="w-4 h-4 mr-2" />
                    {item.name}
                  </button>
                );
              })}
            </nav>
          </div>

          {/* User Menu */}
          <div className="flex items-center">
            <div className="ml-3 relative">
              <div className="flex items-center space-x-3">
                {user && (
                  <span className="text-sm font-medium text-gray-700">
                    {user.name || 'Admin'}
                  </span>
                )}
                <button className="bg-white rounded-full flex text-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
                  <div className="w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center">
                    <span className="text-blue-600 font-medium text-sm">
                      {(user?.name || 'A').charAt(0).toUpperCase()}
                    </span>
                  </div>
                  <ChevronDown className="w-4 h-4 text-gray-400 ml-1 mt-2" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      <div className="md:hidden">
        <div className="pt-2 pb-3 space-y-1 bg-gray-50 border-t border-gray-200">
          {navigation.map((item) => {
            const Icon = item.icon;
            return (
              <button
                key={item.key}
                onClick={() => setCurrentPage(item.key)}
                className={`w-full text-left block pl-3 pr-4 py-2 text-base font-medium transition-colors ${
                  currentPage === item.key
                    ? 'text-blue-700 bg-blue-50 border-r-4 border-blue-500'
                    : 'text-gray-600 hover:text-gray-800 hover:bg-gray-50'
                }`}
              >
                <div className="flex items-center">
                  <Icon className="w-4 h-4 mr-3" />
                  {item.name}
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </header>
  );
};

export default Header;
